export default __webpack_public_path__ + "static/media/(58).284eb902.jpg";